import { useQuery } from '@tanstack/react-query';
import apiClient from '@shared/lib/apiClient';
export const useWhatsAppStatus = () => useQuery({
    queryKey: ['whatsapp', 'status'],
    queryFn: async () => {
        const { data } = await apiClient.get('/whatsapp/health');
        return data;
    },
    staleTime: 1000 * 30,
    retry: 1,
});
